import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'

export const MarketoCampaignSchema = buildEntrySchemaFor('marketoCampaign', {
  fields: z.lazy(() =>
    z.object({
      cDLProgramName: z.string(),
      sFDCLastCampaignStatus: z.union([
        z.literal('Attended'),
        z.literal('Engaged - Success'),
        z.literal('Engaged from Social - Success'),
        z.literal('Engaged from Syndication'),
        z.literal('Engaged from Web - Success'),
        z.literal('Filled Out Form - Success'),
        z.literal('Member'),
        z.literal('Registered'),
        z.literal('Registered from Syndication'),
        z.literal('Responded'),
      ]),
      source: z.string(),
      directToSfdcCampaignId: z.string().optional(),
      additionalProperties: z.looseObject({}).catchall(z.string()).optional(),
    }),
  ),
})

export type MarketoCampaign = z.infer<typeof MarketoCampaignSchema>

export const isMarketoCampaign = (campaign: unknown): campaign is MarketoCampaign => {
  return MarketoCampaignSchema.safeParse(campaign).success
}
